import React from "react";
import "./style.css";

const NewToHippo = () => {
  return <span className="new-to-hippo-tag">New to Hotels hippo</span>;
};

export default NewToHippo;
